import React from "react";
import { Footer, Navbar } from "../components";
import AdsBannerTop from "../components/AdsBannerTop";

const Download = () => {
  return (
    <div>
      <Navbar />
      <AdsBannerTop />
      <header className="bg-hero">
        <section className="py-[60px] grid sm:grid-cols-2 gap-[30px] items-center padding">
          <section className="flex flex-col gap-[20px]">
            <h1 className=" text-white md:text-[50px] sm:text-[40px] text-[30px] poppins font-[600] leading-[110%]">
              Download <span className="text-red font-[700]">FilmJeHub</span>{" "}
              Mobile App
            </h1>
            <p className="text-white opacity-[0.9] mont text-[17px] font-[500]">
              Experience seamless streaming on the go! Download now for instant
              access to your favorite content.
            </p>

            <div className="flex flex-wrap text-nowrap gap-[20px] sm:mt-[1rem]">
              <a href="/Filmjethub.apk" download>
                <button className="outline-none border-none xs:py-[10px] py-[5px] xs:px-[30px] px-[20px] text-white  mont bg-red xs:text-[18px] text-[16px] font-bold rounded-[5px] hover:bg-white hover:text-black  transition">
                  Download APK
                </button>
              </a>
            </div>
          </section>

          <img
            src="/mockup.svg"
            alt="mockup"
            className="w-full xs:h-[700px] h-full"
          />
        </section>
      </header>
      <Footer />
    </div>
  );
};

export default Download;
